module.exports = __webpack_public_path__ + "img/plus-icon.1d31c4fc.svg";